// One id per browser TAB (sessionStorage, not localStorage) so two tabs of
// the SAME master account are treated as two independent writers — both by
// the realtime WebSocket registry (server/src/modules/realtime/registry.ts)
// and by every mutating REST call below, which echoes this id back so the
// server can exclude the originating tab when broadcasting its own change.
const KEY = "sannamai_realtime_client_id";

export function getClientId() {
  try {
    let id = sessionStorage.getItem(KEY);
    if (!id) {
      id = crypto.randomUUID();
      sessionStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    return crypto.randomUUID();
  }
}
